module.exports = __webpack_public_path__ + "static/media/chas-logo.882856ae.svg";